import React, { useState } from "react";
import "./Contact.css";
import NavBar from "../components/Navbar";

const APPS_SCRIPT_URL = "YOUR_APPS_SCRIPT_DEPLOYMENT_URL"; // <-- paste your Web App URL

const Contact = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const [status, setStatus] = useState("idle"); // idle | sending | success | error

  const onChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!APPS_SCRIPT_URL || APPS_SCRIPT_URL.includes("YOUR_APPS_SCRIPT")) {
      alert("Apps Script URL not configured.");
      return;
    }
    setStatus("sending");
    try {
      const res = await fetch(APPS_SCRIPT_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        // If you added a token in Apps Script, include it here too:
        // body: JSON.stringify({ token: "SECRET123", ...form }),
        body: JSON.stringify(form),
      });
      const json = await res.json().catch(() => ({}));
      if (res.ok && json.ok) {
        setStatus("success");
        // Clear the form after successful submit
        setForm({ name: "", email: "", phone: "", message: "" });
      } else {
        setStatus("error");
      }
    } catch (err) {
      setStatus("error");
    } finally {
      // Reset UI status after a moment
      setTimeout(() => setStatus("idle"), 2000);
    }
  };

  return (
    <>
      <NavBar textColor="#000" />
      <div className="contact-page">
        {/* Header */}
        <h1 className="contact-title">CONTACT US</h1>
        <p className="contact-subtitle">
          📞 +31-347-38-41-73 &nbsp; | &nbsp; 📧 info@hollandtahini.com
        </p>

        <hr />

        {/* FAQ Intro */}
        <div className="faq-intro">
          <h2>FREQUENTLY ASKED QUESTIONS</h2>
          <p>
            Before you contact us, you might want to check our{" "}
            <a href="/faq">FAQ</a> page where we’ve answered the most common
            questions about our products and services.
          </p>
        </div>

        {/* Get in Touch Form (submit-only) */}
        <section className="contact-form" aria-labelledby="get-in-touch-heading">
          <h2 id="get-in-touch-heading" className="contact-form__title">
            Get in Touch
          </h2>

          <form className="contact-form__form" onSubmit={onSubmit}>
            <div className="contact-form__row">
              <div className="contact-form__field">
                <label htmlFor="cf-name" className="contact-form__label">
                  Your Name
                </label>
                <input
                  id="cf-name"
                  name="name"
                  type="text"
                  className="contact-form__input"
                  placeholder="Your Name"
                  value={form.name}
                  onChange={onChange}
                  required
                />
              </div>

              <div className="contact-form__field">
                <label htmlFor="cf-email" className="contact-form__label">
                  Your Email
                </label>
                <input
                  id="cf-email"
                  name="email"
                  type="email"
                  className="contact-form__input"
                  placeholder="you@example.com"
                  value={form.email}
                  onChange={onChange}
                  required
                />
              </div>
            </div>

            <div className="contact-form__row">
              <div className="contact-form__field">
                <label htmlFor="cf-phone" className="contact-form__label">
                  Phone Number (optional)
                </label>
                <input
                  id="cf-phone"
                  name="phone"
                  type="text"
                  className="contact-form__input"
                  placeholder="+31 ..."
                  value={form.phone}
                  onChange={onChange}
                />
              </div>
            </div>

            <div className="contact-form__row">
              <div className="contact-form__field">
                <label htmlFor="cf-message" className="contact-form__label">
                  Your Message
                </label>
                <textarea
                  id="cf-message"
                  name="message"
                  rows={5}
                  className="contact-form__textarea"
                  placeholder="How can we help?"
                  value={form.message}
                  onChange={onChange}
                  required
                />
              </div>
            </div>

            <div className="contact-form__status" aria-live="polite">
              {status === "sending" && <span>Sending…</span>}
              {status === "success" && <span>Sent ✓</span>}
              {status === "error" && (
                <span style={{ color: "#c00" }}>
                  Couldn’t send. Check your endpoint.
                </span>
              )}
            </div>

            <button
              type="submit"
              className="contact-form__submit"
              disabled={status === "sending"}
            >
              {status === "sending" ? "Sending…" : "Send Message"}
            </button>
          </form>
        </section>

        {/* Google Map */}
        <div className="map-container">
          <iframe
            title="Holland Tahini Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2457.3457791675496!2d5.096728!3d51.98235099999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c663ee85e22247%3A0xfce95e22f8c20a80!2sSportlaan%203e%2C%204131%20NN%20Vianen%2C%20Netherlands!5e0!3m2!1sen!2sin!4v1757656450127!5m2!1sen!2sin"
            width="100%"
            height="400"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
    </>
  );
};

export default Contact;
